import React, { Fragment } from 'react';
import { Card } from 'react-bootstrap';
import Breadcrumbs from '../Reusable/Breadcrumbs';

const BreadcrumbsDemo = () => {
  const data = [
    {
      id: 1,
      name: 'eSokoj',
      href: '/dashboard',
    },
    {
      id: 2,
      name: 'Sistem raspodele',
      href: '/dashboard',
    },
    {
      id: 3,
      name: 'Raspodela autorske naknade',
      href: '/dashboard',
    },
    {
      id: 4,
      name: 'Vođenje analitike Fonda za raspodelu tantijema, po klasama raspodele',
    },
  ];

  return (
    <Fragment>
      <Card className={`table-card-style`}>
        <Card.Header className="table-card-header-style">
          <Card.Title className="d-flex gap-3 align-items-center">
            Breadcrumbs
          </Card.Title>
        </Card.Header>
        <Card.Body>
          <Breadcrumbs data={data} />
        </Card.Body>
      </Card>
    </Fragment>
  );
};

export default BreadcrumbsDemo;
